<ng-container
  *ngTemplateOutlet="
    layoutTemplate || defaultLayoutTemplate;
    context: { horizontalSliderTemplate, itemListTemplate }
  "
/>

<ng-template #defaultLayoutTemplate>
  <ng-container *ngTemplateOutlet="horizontalSliderTemplate" />

  <ng-container *ngTemplateOutlet="itemListTemplate" />
</ng-template>

<ng-template #horizontalSliderTemplate>
  @if (displaySlider()) {
    <pxw-horizontal-slider [ngClass]="{ 'visible-hidden': !displayHorizontalSlider }">
      @for (itemListGroup of itemListGroups; track itemListGroup.group.id) {
        <pxw-horizontal-slider-item [id]="itemListGroup.group.id">
          <pxw-button
            [color]="'theme2-contrast'"
            [appareance]="itemListGroup.group.id === _selectedGroupId ? 'solid' : 'outline'"
            [rounded]="true"
            size="md"
            (click)="onSliderItemClick(itemListGroup.group.id)"
          >
            {{ itemListGroup.group.name }}
          </pxw-button>
        </pxw-horizontal-slider-item>
      }
    </pxw-horizontal-slider>
  }
</ng-template>

<ng-template #itemListTemplate>
  <div
    class="item-list__wrapper"
    #scrollTarget
    pxwScrollBreaksWrapper
    pxwDetectScroll
    [scrollOffset]="1"
    [invalidateValue]="itemListGroups"
    (scroll.zoneless)="onProductListScroll($event)"
    (breakItemActiveChange)="onBreakItemActiveChange($event)"
    (scrollStateChange)="onScrollStateChange($event)"
  >
    @if (itemListGroups.length > 0) {
      <ng-template #defaultGroupHeadingTemplate let-group="group" let-groupItem="groupItem">
        <h2 class="item-list__group-heading">
          <span class="item-list__group-title">
            {{ group.name }}
            <span class="item-list__group-count">({{ groupItem.indexedItems.length }})</span>
          </span>
        </h2>
      </ng-template>
      @for (itemListGroup of itemListGroups; track itemListGroup.group.id) {
        <div class="item-list__group" pxwScrollBreakItem [id]="itemListGroup.group.id">
          @if (displayHeadings) {
            <ng-container
              *ngTemplateOutlet="
                groupHeadingTemplate || defaultGroupHeadingTemplate;
                context: { group: itemListGroup.group, groupItem: itemListGroup }
              "
            ></ng-container>
          }

          <div class="item-list-grid">
            @for (indexedProduct of itemListGroup.indexedItems; track indexedProduct.itemId) {
              @if (indexedProduct.listIndex < initialRenderItemsQty) {
                <ng-container
                  *ngTemplateOutlet="
                    listItemTemplate;
                    context: {
                      group: itemListGroup.group,
                      item: indexedProduct.item,
                      index: indexedProduct.listIndex,
                    }
                  "
                ></ng-container>
              } @else {
                @defer (on viewport({rootMargin: '150px'})) {
                  <div class="ui-animation--fade-in">
                    <ng-container
                      *ngTemplateOutlet="
                        listItemTemplate;
                        context: {
                          group: itemListGroup.group,
                          item: indexedProduct.item,
                          index: indexedProduct.listIndex,
                        }
                      "
                    ></ng-container>
                  </div>
                } @placeholder {
                  <div class="ui-skeleton" [style.min-height.px]="itemHeight"></div>
                }
              }
            }
          </div>
        </div>
      }
    } @else {
      <div class="item-list__empty-state">
        {{ emptyListText }}
      </div>
    }
  </div>
</ng-template>
